import React from 'react';

import { Chip, ChipProps } from '@/components/shared/Chip';

import styles from './ActionContent.module.scss';

export type SlotActionRowProps = {
	label: React.ReactNode;
	middleContent?: React.ReactNode;
	primaryAction: {
		label: string;
		onClick: () => void;
		disabled?: boolean;
		color?: ChipProps['color'];
	};
};

export const SlotActionRow: React.FC<SlotActionRowProps> = ({
	label,
	middleContent,
	primaryAction,
}) => {
	return (
		<div className={styles['slot-row']}>
			<span className={styles['slot-label']}>{label}</span>

			{middleContent && (
				<div className={styles['slot-middle']}>{middleContent}</div>
			)}

			<Chip
				color={primaryAction.color || 'light-blue'}
				variant="rounded"
				disabled={primaryAction.disabled}
				onClick={
					primaryAction.disabled
						? undefined
						: primaryAction.onClick
				}
			>
				{primaryAction.label}
			</Chip>
		</div>
	);
};
